/** Every shipment grid the Shipments page can show, keyed by the server component it reads. */
const SHIPMENT_TABLES = ['il_ocean_import', 'il_ocean_export', 'il_air_import', 'il_air_export', 'il_ftl_ltl'];

const freshTableFlags = () =>
    Object.fromEntries(
        SHIPMENT_TABLES.map((table) => [
            table,
            { inprogress: false, complete: false, completeWindow: null, latestRead: null },
        ])
    );

/**
 * Remembers which grids, and whether the todo list, were already loaded on the
 * connection the operator is on now. Coming back to a grid already loaded shows it
 * at once; anything loaded on an earlier connection is treated as possibly stale.
 * `completeWindow` is the date window the COMPLETE rows were read with (OS-587): a
 * grid whose window no longer matches the one the operator picked is read again.
 * `latestRead` marks the grid's most recent read, so a slower earlier reply is not shown.
 */
export const createShipmentReadCache = () => ({
    epoch: null,
    todoEpoch: null,
    tables: freshTableFlags(),
});

/**
 * Forget every "already read" mark when the socket has reconnected since the last
 * read. Edits broadcast while the tab was cut off never arrive retroactively, so a
 * grid read on an earlier connection may show a status, container or todo that a
 * teammate has since changed — only a fresh read from the server closes that gap.
 * Returns true when the marks were wiped.
 */
export const syncReadCacheToConnection = (cache, connectionEpoch) => {
    if (cache.epoch === connectionEpoch) return false;
    cache.tables = freshTableFlags();
    cache.epoch = connectionEpoch;
    return true;
};

/**
 * Shared by every visit to the Shipments page, so an operator who leaves for the
 * Taskboard and comes back sees the rows already loaded instead of waiting for a
 * fresh download (the rows themselves stay in Redux the same way).
 */
export const shipmentReadCache = createShipmentReadCache();
